<div class="transaction-item-details">

  <bb-modal-ui [isOpen]="_isOpen"
    [modalOptions]="modalOptions"
    (cancel)="closeDialog()">
    <bb-modal-header-ui [attr.data-role]="'modal-header'">
      <ng-template bbCustomModalHeader>
        <div class="bb-stack">

          <div class="bb-stack__item--push-right bn-transaction-item-details__close-button">
            <div class="bb-stack">
              <button (click)="closeDialog()"
                bbButton
                class="bb-stack__item-sm"
                color="unstyled"
                aria-label="close dialog">
                <bb-icon-ui color="muted"
                  name="clear"></bb-icon-ui>
              </button>
            </div>
          </div>
        </div>
      </ng-template>
    </bb-modal-header-ui>
    <bb-modal-body-ui>
      <ng-template bbCustomModalBody>
        <div class="transaction-item-details__detalle">
          <div class="bb-block--md pb-4">
            <div>
              <div class="account-name">{{ description }}</div>
              <div class="balance">{{ ammount }}</div>
            </div>
            <div>
              <div class="categoryLabel">{{ getCategoryName(typeGroup) }}</div>
              <div i18n="@@transactions.modal.monto">Amount</div>
            </div>
            <div>
              <button style="display: none;"
                i18n="@@transactions.modal.categoryButton">Change category</button>
            </div>
          </div>
          <div class="bb-block--md pb-4">
            <h3 i18n="@@transactions.modal.DetailsLabel">Details</h3>
            <ul>
              <li>
                <label i18n="@@transactions.modal.bookingDateLabel">Booking date</label>
                <span>{{ bookingDate | bnEsDate | bnEmpty: "__ __" }}</span>
              </li>
              <li>
                <label i18n="@@transactions.modal.asettlementDateLabel">Application date</label>
                <span>{{ asettlementDate | bnEsDate | bnEmpty: "__ __"  }}</span>
              </li>
              <li>
                <label i18n="@@transactions.modal.descriptionLabel">Description</label>
                <span>{{ description | bnEmpty: "__ __" }}</span>
              </li>
              <li *ngIf="showCheckNumber">
                <label i18n="@@transactions.modal.checkNumberLabel">
                  Check number
                </label>
                <span>{{ checkNumber | bnEmpty: "__ __" }}</span>
              </li>
              <li>
                <label i18n="@@transactions.modal.debitAmountLabel">Debit amount</label>
                <span>{{ debitAmount | bnEmpty: "__ __" }}</span>
              </li>
              <li>
                <label i18n="@@transactions.modal.creditAmountLabel">Credit amount</label>
                <span>{{ creditAmount | bnEmpty: "__ __" }}</span>
              </li>
              <li *ngIf="showBillingStatus === true">
                <label i18n="@@transactions.modal.billingStatusLabel">Billing status</label>
                <span>{{ mapBillingStatus(billingStatus) }}</span>
              </li>
              <li *ngIf="!isEmpty(balanceAfterTransaction) && !!showBalance">
                <label i18n="@@transactions.modal.balanceAfterTransactionLabel">Account balance</label>
                <span>{{ balanceAfterTransaction | bnEmpty: "__ __" }}</span>
              </li>
              <li *ngIf="!!showApprovalCode">
                <label i18n="@@transactions.modal.approvalCodeLabel">Approval code</label>
                <span>{{ approvalCode | bnEmpty: "__ __" }}</span>
              </li>
              <li>
                <label i18n="@@transactions.modal.referenceLabel">Reference number</label>
                <span>{{ reference | bnEmpty: "__ __" }}</span>
              </li>
            </ul>
          </div>
          <!-- Check Images -->
          <div *ngIf="showCheckNumber"
            class="bn-transaction-item-details__container pb-4">
            <div class="bn-transaction-item-details__checks">
              <div class="my-3">
                <h3 i18n="@@transactions.modal.checkImages"
                  style="display: inline;">
                  Check images
                </h3>
                <bn-semaphore-tooltip i18n-text="@@transactions.modal.tooltip"
                  text="Check images are available on BanescOnline the next working day after deposit"
                  type="info"></bn-semaphore-tooltip>
              </div>
              <ng-container *ngIf="loadingCheckImages">
                <div class="bb-state-container">
                  <bb-loading-indicator-ui loaderSize="md"></bb-loading-indicator-ui>
                </div>
              </ng-container>
              <ng-container *ngIf="checkImages$ | async; let checkImages">
                <div *ngIf="checkImages.length > 0"
                  class="bn-transaction-item-details__checks__images">
                  <div class="mr-4">
                    <label i18n="@@transactions.modal.front">Front</label>
                    <div class="card bg-dark text-white"
                      (click)="openCarousel('front')">
                      <img [src]="checkImages[0]"
                        class="card-img rounded"
                        alt="...">
                      <div
                        class="custom-overlay card-img-overlay d-flex justify-content-center align-items-center rounded"
                        style="background: rgba(0,0,0,0.6);">
                        <bb-icon-ui name="visibility"
                          size="xl"></bb-icon-ui>
                      </div>
                    </div>
                  </div>
                  <div>
                    <label i18n="@@transactions.modal.back">Back</label>
                    <div class="card bg-dark text-white"
                      (click)="openCarousel('back')">
                      <img [src]="checkImages[1]"
                        class="card-img rounded"
                        alt="...">
                      <div
                        class="custom-overlay card-img-overlay d-flex justify-content-center align-items-center rounded"
                        style="background: rgba(0,0,0,0.6);">
                        <bb-icon-ui name="visibility"
                          size="xl"></bb-icon-ui>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="checkImages.length === 0">
                  <label i18n="@@transactions.modal.noImagesYet"
                    class="text-muted font-weight-light">No check images yet</label>
                </div>
                <bb-modal-ui [isOpen]="carouselIsOpened"
                  (cancel)="closeCarousel()"
                  *ngIf="checkImages">
                  <bb-modal-body-ui>
                    <ng-template bbCustomModalBody>
                      <ngb-carousel>
                        <ng-template ngbSlide
                          id="front">
                          <div>
                            <img class="w-100"
                              [src]="checkImages[0]"
                              alt="Check Image (Front)">
                          </div>
                        </ng-template>
                        <ng-template ngbSlide
                          id="back">
                          <div>
                            <img class="w-100"
                              [src]="checkImages[1]"
                              alt="Check Image (Back)">
                          </div>
                        </ng-template>
                      </ngb-carousel>
                    </ng-template>
                  </bb-modal-body-ui>
                </bb-modal-ui>
              </ng-container>
            </div>
          </div>


          <div class="bn-transaction-item-details__container pb-4">
            <div>
              <div>
                <button *ngIf="!isEditingNotes && !_transaction?.notes"
                  class="mt-4"
                  (click)="isEditingNotes = true"
                  i18n="@@transactions.modal.addNoteButton">Add note</button>
              </div>

              <div class="bn-transaction-item-details__note"
                *ngIf="isEditingNotes || _transaction?.notes">
                <div class="bn-transaction-item-details__note__actions">
                  <h3 i18n="@@transactions.modal.noteLabel">Note</h3>
                  <div *ngIf="!isEditingNotes && currentNote">
                    <a (click)="isEditingNotes = true">
                      <bb-icon-ui name="edit"
                        size="md"
                        color="secondary"></bb-icon-ui>
                    </a>
                    <a (click)="deleteNote(_transaction)"
                      class="ml-2">
                      <bb-icon-ui name="delete"
                        size="md"
                        color="secondary"></bb-icon-ui>
                    </a>
                  </div>
                </div>
                <div *ngIf="!isEditingNotes && currentNote">
                  {{ currentNote }}
                </div>
                <div *ngIf="isEditingNotes">
                  <form [formGroup]="notesForm">
                    <bb-textarea-ui label=""
                      placeholder=" A message to remember the concept of your transaction."
                      formControlName="notes"
                      [showCharCounter]="true"
                      [minLength]=""
                      [maxLength]=""
                      [rows]="2">
                    </bb-textarea-ui>
                  </form>
                  <div class="bb-button-bar">
                    <button [disabled]="saving"
                      class="m-2 btn-primary btn-md btn bn-transaction-item-details__button"
                      (click)="updateNote(_transaction, notesForm.get('notes').value)"
                      i18n="@@transactions.modal.save">Save</button>
                    <button class="m-2 btn-secondary btn-md btn bn-transaction-item-details__button"
                      (click)="cancelUpdateNote()"
                      data-role="cancel"
                      color="secondary"
                      i18n="@@transactions.modal.cancel">Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </ng-template>
    </bb-modal-body-ui>
    <bb-modal-footer-ui #footerRef
      [attr.data-role]="'modal-footer'">
      <ng-template bbCustomModalFooter>
        <div class="bb-button-bar"
          *ngIf="!isEditingNotes">
        </div>
      </ng-template>
    </bb-modal-footer-ui>
  </bb-modal-ui>
</div>